// extracted by mini-css-extract-plugin
export var aiChatCartContainer = "_dk-2";
export var aiChatCartContainerExit = "_dk-4";
export var aiChatContainerLarge = "_dk-0";
export var aiChatContainerSmall = "_dk-1";
export var aiChatIcon = "_dk-6";
export var slideInFromRight = "_dk-3";
export var slideOutToRight = "_dk-5";